function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNeighborlyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2084 2084",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-Group-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Path-",
    d: "M1834.89,671.869l-876.316,-410.66c-7.185,-3.225 -14.866,-4.959 -22.542,-4.959c-7.681,-0 -15.356,1.734 -22.541,5.204l-430.977,202.856l-15.105,7.185l-0,-132.27c-0,-29.475 -23.78,-53.249 -53.004,-53.249l-349.987,-0c-29.469,-0 -53.249,23.774 -53.249,53.249l-0,1434.6c-0,29.475 23.78,53.255 53.249,53.255l349.987,-0c29.224,-0 53.004,-23.78 53.004,-53.255l-0,-797.798l6.192,-2.973l458.465,-216.227l4.463,-1.986l4.457,1.986l462.18,216.478l5.947,2.967l-0,797.553c-0,29.475 23.78,53.255 53.255,53.255l349.981,-0c29.224,-0 53.004,-23.78 53.004,-53.255l-0,-1053.91c-0,-20.556 -11.887,-39.382 -30.463,-48.051Z",
    style: {
      fill: "#ffffff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_-Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Compound-Path-",
    d: "M2072.17,772.433c0,29.72 -23.277,53.004 -53.745,53.004c-30.217,-0 -54.243,-23.284 -54.243,-53.004c0,-29.23 24.026,-52.759 54.243,-52.759c30.468,0 53.745,23.529 53.745,52.759Zm-94.611,-0c-0,23.283 17.337,41.858 41.111,41.858c23.038,0 40.13,-18.575 40.13,-41.613c-0,-23.529 -17.092,-42.355 -40.375,-42.355c-23.529,-0 -40.866,18.826 -40.866,42.11Zm32.443,27.495l-12.133,-0l0,-52.514c4.702,-0.987 11.636,-1.734 20.31,-1.734c9.907,-0 14.364,1.734 18.079,3.966c2.973,2.225 5.199,6.437 5.199,11.39c-0,5.947 -4.457,10.404 -10.894,12.139l-0,0.741c5.199,1.986 7.926,5.701 9.656,12.88c1.489,7.927 2.476,11.146 3.715,13.132l-13.126,-0c-1.484,-1.986 -2.476,-6.689 -4.211,-12.88c-0.742,-5.701 -3.961,-8.424 -10.894,-8.424l-5.701,0l-0,21.304Zm0.251,-29.727l5.94,0c6.689,0 12.139,-2.225 12.139,-7.675c-0,-4.708 -3.47,-7.927 -11.146,-7.927c-3.218,0 -5.45,0.246 -6.933,0.497l-0,15.105Z",
    style: {
      fill: "#ffffff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNeighborlyWhite);
export default __webpack_public_path__ + "static/media/logo-neighborly-white.c166ee61267b2b5e92a66cc56671bb5b.svg";
export { ForwardRef as ReactComponent };